import { API_BASE } from '../config';
import { getAuthToken } from '../utils/authStorage';

// Helper function to get auth headers
const authHeaders = async () => {
  const token = getAuthToken();
  if (!token) {
    throw new Error('No authentication token found');
  }
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };
};

// Get all alerts with optional filters
export async function getAlerts(params = {}) {
  const queryParams = new URLSearchParams();
  
  if (params.skip !== undefined) queryParams.append('skip', params.skip);
  if (params.limit !== undefined) queryParams.append('limit', params.limit);
  if (params.is_resolved !== undefined) queryParams.append('is_resolved', params.is_resolved);
  if (params.chemical_id !== undefined) queryParams.append('chemical_id', params.chemical_id);
  
  const url = `${API_BASE}/alerts/?${queryParams.toString()}`;
  const res = await fetch(url, {
    headers: await authHeaders()
  });
  
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.detail || 'Failed to fetch alerts');
  }
  
  return res.json();
}

// Get unresolved alerts
export async function getUnresolvedAlerts() {
  const res = await fetch(`${API_BASE}/alerts/unresolved`, {
    headers: await authHeaders()
  });
  
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.detail || 'Failed to fetch unresolved alerts');
  }
  
  return res.json();
}

// Get a specific alert by ID
export async function getAlert(alertId) {
  const res = await fetch(`${API_BASE}/alerts/${alertId}`, {
    headers: await authHeaders()
  });
  
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.detail || 'Failed to fetch alert');
  }
  
  return res.json();
}

// Update an alert
export async function updateAlert(alertId, updateData) {
  const res = await fetch(`${API_BASE}/alerts/${alertId}`, {
    method: 'PUT',
    headers: await authHeaders(),
    body: JSON.stringify(updateData)
  });
  
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.detail || 'Failed to update alert');
  }
  
  return res.json();
}

// Resolve an alert
export async function resolveAlert(alertId) {
  const res = await fetch(`${API_BASE}/alerts/${alertId}/resolve`, {
    method: 'POST',
    headers: await authHeaders()
  });
  
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.detail || 'Failed to resolve alert');
  }
  
  return res.json();
}

// Delete an alert
export async function deleteAlert(alertId) {
  const res = await fetch(`${API_BASE}/alerts/${alertId}`, {
    method: 'DELETE',
    headers: await authHeaders()
  });
  
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.detail || 'Failed to delete alert');
  }
  
  return res.json();
}
